if (!customElements.get('brand-logo-marquee')) {
  class BrandLogoMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-logo-track]');
      this.group = this.querySelector('[data-logo-group]');
      this.logoCount = Number(this.dataset.logoCount || 0);
      this.desktopThreshold = Number(this.dataset.desktopThreshold || 0);
      this.mobileThreshold = Number(this.dataset.mobileThreshold || 0);
      this.mobileQuery = window.matchMedia('(max-width: 767.98px)');
      this.handleResize = this.handleResize.bind(this);
      this.handleSectionLoad = this.handleSectionLoad.bind(this);

      this.init();
      window.addEventListener('resize', this.handleResize);
      document.addEventListener('shopify:section:load', this.handleSectionLoad);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('shopify:section:load', this.handleSectionLoad);
    }

    handleSectionLoad(event) {
      if (event.detail.sectionId === this.dataset.sectionId) this.init();
    }

    handleResize() {
      window.clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(() => {
        const nextMode = this.mobileQuery.matches ? 'mobile' : 'desktop';
        if (nextMode !== this.currentMode || this.classList.contains('is-animated')) {
          this.init();
        }
      }, 150);
    }

    init() {
      if (!this.track || !this.group) return;

      this.currentMode = this.mobileQuery.matches ? 'mobile' : 'desktop';
      this.clearClones();

      const threshold = this.currentMode === 'mobile' ? this.mobileThreshold : this.desktopThreshold;
      const shouldAnimate = this.logoCount > threshold && !window.FoxTheme?.config?.motionReduced;

      this.classList.toggle('is-animated', shouldAnimate);
      this.classList.toggle('is-static', !shouldAnimate);

      if (!shouldAnimate) {
        this.style.removeProperty('--brand-logo-marquee-distance');
        return;
      }

      window.requestAnimationFrame(() => this.buildLoop());
    }

    clearClones() {
      this.track.querySelectorAll('[data-logo-clone]').forEach((clone) => clone.remove());
      this.track.style.animation = 'none';
      this.track.offsetHeight;
      this.track.style.animation = '';
    }

    buildLoop() {
      const distance = Math.ceil(this.group.getBoundingClientRect().width);
      const viewportWidth = Math.ceil(this.getBoundingClientRect().width);

      if (!distance || !viewportWidth) return;

      this.style.setProperty('--brand-logo-marquee-distance', `${distance}px`);

      let safety = 0;
      while (this.track.scrollWidth < viewportWidth + distance * 2 && safety < 8) {
        const clone = this.group.cloneNode(true);
        clone.setAttribute('data-logo-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        this.track.appendChild(clone);
        safety += 1;
      }
    }
  }

  customElements.define('brand-logo-marquee', BrandLogoMarquee);
}
